class MegaMenu extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector("[data-mega-panel]");
    this.overlay = this.querySelector("[data-mega-overlay]");
    this.trigger = document.querySelector("[data-mega-trigger]");
    this.caret = this.trigger?.querySelector("[data-mega-caret]");
    this.isOpen = false;
    this.activeIndex = 0;
    if (!this.trigger || !this.panel) return;
    this.trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      this.isOpen ? this.close() : this.open();
    });
    this.overlay?.addEventListener("click", () => this.close());
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) this.close();
    });
    this.querySelectorAll("[data-menu-item]").forEach((item) => {
      item.addEventListener("click", () => {
        const index = item.getAttribute("data-menu-item");
        this.setActive(index);
      });
    });
    this.querySelectorAll("[data-menu-children] a, [data-menu-link]").forEach((link) => {
      link.addEventListener("click", () => this.close());
    });
    this.querySelectorAll("[data-toggle-links]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const list = btn.previousElementSibling;
        const hidden = list.querySelectorAll("[data-extra-link].hidden");
        if (hidden.length > 0) {
          hidden.forEach((li) => li.classList.remove("hidden"));
          btn.textContent = btn.dataset.less;
        } else {
          list.querySelectorAll("[data-extra-link]").forEach((li) => li.classList.add("hidden"));
          btn.textContent = btn.dataset.more;
        }
      });
    });
    const firstItem = this.querySelector("[data-menu-item]");
    if (firstItem) this.setActive(firstItem.getAttribute("data-menu-item"));
  }
  open() {
    this.isOpen = true;
    this.panel.classList.remove("-translate-y-full", "invisible");
    this.panel.classList.add("translate-y-0");
    this.overlay.classList.remove("opacity-0", "pointer-events-none");
    this.overlay.classList.add("opacity-100");
    this.trigger.setAttribute("aria-expanded", "true");
    this.caret?.classList.add("rotate-180");
    document.body.classList.add("overflow-hidden");
  }
  close() {
    this.isOpen = false;
    this.panel.classList.add("-translate-y-full", "invisible");
    this.panel.classList.remove("translate-y-0");
    this.overlay.classList.add("opacity-0", "pointer-events-none");
    this.overlay.classList.remove("opacity-100");
    this.trigger.setAttribute("aria-expanded", "false");
    this.caret?.classList.remove("rotate-180");
    document.body.classList.remove("overflow-hidden");
  }
  setActive(index) {
    this.activeIndex = index;
    this.querySelectorAll("[data-menu-item]").forEach((item) => {
      if (item.getAttribute("data-menu-item") === index) {
        item.classList.add("bg-primary-light/20", "font-semibold");
        item.classList.remove("hover:bg-gray-50");
      } else {
        item.classList.remove("bg-primary-light/20", "font-semibold");
        item.classList.add("hover:bg-gray-50");
      }
    });
    this.querySelectorAll("[data-menu-children]").forEach((panel) => {
      if (panel.getAttribute("data-menu-children") === index) {
        panel.classList.remove("hidden");
      } else {
        panel.classList.add("hidden");
        panel.querySelectorAll("[data-extra-link]").forEach((li) => li.classList.add("hidden"));
        panel.querySelectorAll("[data-toggle-links]").forEach((btn) => {
          btn.textContent = btn.dataset.more;
        });
      }
    });
  }
}
customElements.define("mega-menu", MegaMenu);
